module.exports = __webpack_public_path__ + "img/logo1 (37).8e4557a0.jpg";